import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';

export const wildcard404RedirectGuard: CanActivateFn = () => {
  const router = inject(Router);

  // Replace the bad URL in history so Back returns to the previous page.
  return new RedirectCommand(router.parseUrl('/404'), { replaceUrl: true });
};
